export default "__VITE_ASSET__GPk9ctM$__"